import Link from 'next/link'
import React from 'react'

export default function CommonTechGrid({
   gridTitle,
   gridSubTitle,
   gridTechbody = null,
   gridDesc,
   gridContent,
}) {
   const gridSize = gridContent.length

   // Map industry titles to their respective URL paths
   const getIndustryPath = (title) => {
      // Special case for healthcare
      if (title.toLowerCase() === 'healthcare') {
         return '/industries/health-fitness-software-development-solutions'
      }

      const industryPathMap = {
         'Health & Fitness':
            '/industries/health-fitness-software-development-solutions',
         'Finance & Banking':
            '/industries/fintech-software-development-solutions',
         'Banking & Finance':
            '/industries/fintech-software-development-solutions',
         'Restaurant & Hospitality':
            '/industries/restaurant-hospitality-software-solutions',
         'Restaurants & Hospitality':
            '/industries/restaurant-hospitality-software-solutions',
         'E-Commerce': '/industries/e-commerce-software-development-solutions',
         'Enhanced eCommerce':
            '/industries/e-commerce-software-development-solutions',
         'Supply Chain & Logistics':
            '/industries/supply-chain-logistics-software-solutions',
         'Logistics & Supply Chain':
            '/industries/supply-chain-logistics-software-solutions',
         'Social Networking':
            '/industries/social-dating-software-development-solutions',
         'Gaming & Sports Analytics':
            '/industries/gaming-sports-software-development-solutions',
         'Travel & Tourism':
            '/industries/travel-tourism-software-development-solutions',
         'Real Estate':
            '/industries/real-estate-software-development-solutions',
         'Real Estate Solutions':
            '/industries/real-estate-software-development-solutions',
         'Education & E-Learning':
            '/industries/education-software-development-solutions',
         'Media & Entertainment':
            '/industries/media-entertainment-software-solutions',
         'Government & Public Sector':
            '/industries/government-public-sector-software-solutions',
      }
      return industryPathMap[title] || null
   }

   return (
      <section className="container-fluid py-5 section_secondary_bg">
         <div className="container text-center mb-5 innovation_comman">
            <h2 className="tech_title section_heading_title mb-2">
               {gridTitle}
            </h2>
            <h2 className="tech_title section_heading_title mb-2">
               {gridSubTitle}
            </h2>
            {gridTechbody && <p className="tech_body">{gridTechbody}</p>}
            <p className="sub_body">{gridDesc}</p>
         </div>

         <div className="container text-center">
            <div className="innovation_card_main">
               <div className="row g-4  industry-grid tech_industry_grid">
                  {gridContent.map((industry, index) => {
                     const industryPath = getIndustryPath(industry.title)
                     const CardContent = (
                        <div
                           className="industry-card"
                           style={{
                              cursor: industryPath ? 'pointer' : 'default',
                           }}
                        >
                           <h3 className="industry-title">{industry.title}</h3>
                           <div className="icon-circle">
                              {!industry?.url && industry?.icon}
                              {!industry?.icon && (
                                 <img
                                    src={industry?.url}
                                    alt={industry.title + ' Icon'}
                                 />
                              )}
                           </div>
                           <h4 className="industry-subtitle">
                              {industry.subtitle}
                           </h4>
                           <p className="industry-description">
                              {industry.description}
                           </p>
                        </div>
                     )

                     return (
                        <div
                           key={index}
                           className={`col-lg-4 col-md-6 industry-card-wrapper ${
                              index > gridSize - 4 ? '' : 'line-before'
                           }`}
                        >
                           {industryPath ? (
                              <Link
                                 href={industryPath}
                                 style={{
                                    textDecoration: 'none',
                                    color: 'inherit',
                                 }}
                              >
                                 {CardContent}
                              </Link>
                           ) : (
                              CardContent
                           )}
                        </div>
                     )
                  })}
               </div>
            </div>
            <Link
               href="/discover-benzatine/contact-us"
               className="btn bez-fill-btn mt-4"
            >
               Discover your business requirements
               <svg
                  width="37"
                  className="img-fluid"
                  height="37"
                  viewBox="0 0 37 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
               >
                  <g clipPath="url(#clip0_5116_214025)">
                     <path
                        d="M36.2699 17.749L28.0882 9.56725C27.7943 9.22406 27.2778 9.18405 26.9347 9.47803C26.5915 9.77193 26.5515 10.2884 26.8454 10.6316C26.8729 10.6637 26.9026 10.6934 26.9347 10.7208L33.7172 17.5117H1.32595C0.874134 17.5117 0.507812 17.878 0.507812 18.3299C0.507812 18.7818 0.874134 19.148 1.32595 19.148H33.7172L26.9347 25.9306C26.5915 26.2245 26.5515 26.741 26.8454 27.0842C27.1394 27.4274 27.6558 27.4674 27.999 27.1734C28.0311 27.1459 28.0608 27.1162 28.0882 27.0842L36.2699 18.9025C36.5871 18.5835 36.5871 18.0681 36.2699 17.749Z"
                        fill="#F4F2F0"
                     />
                  </g>
                  <defs>
                     <clippath id="clip0_5116_214025">
                        <rect
                           width="36"
                           height="36"
                           fill="white"
                           transform="translate(0.507812 0.324219)"
                        />
                     </clippath>
                  </defs>
               </svg>
            </Link>
         </div>
      </section>
   )
}
